import React from "react";

// Hooks
import useTranslate from "src/hooks/useTranslate";

// Components
import CustomField from "src/components/CustomField";

const WhenStep = () => {
  const getText = useTranslate();

  return (
    <>
      <CustomField
        label={getText(
          "caseDetailPage.requiredIncidentDetails.dateTimeSubtitle"
        )}
        name="dateTime"
        type="dateTime"
      />
    </>
  );
};

export default WhenStep;
